import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';

export const rolesArray = {
  root: 'Root',
  teacher: 'Docente',
  student: 'Estudiante',
  admin: 'Admin',
  entity: 'Institucional',
  family: 'Representante',
  user: 'Usuario',
};

const SelectFieldRolesComponent = ({
  onChange,
  value = '',
  required = false,
  error = false,
}) => {
  const loginStore = Redux.useSelector((state) => state.login);

  return (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`label_${CONST.rol.name}`}>{CONST.rol.label}</InputLabel>
      <Select
        id="select-roles"
        value={value}
        labelId={`label_${CONST.rol.name}`}
        label={CONST.rol.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {loginStore.isRoot && <MenuItem value="admin">ADMIN</MenuItem>}
        <MenuItem value="entity">INSTITUCIONAL</MenuItem>
        <MenuItem value="teacher">DOCENTE</MenuItem>
        <MenuItem value="family">FAMILIAR</MenuItem>
        <MenuItem value="student">ESTUDIANTE</MenuItem>
        {loginStore.isRoot && <MenuItem value="user">USUARIO</MenuItem>}
      </Select>
    </FormControl>
  );
};

export default SelectFieldRolesComponent;
